import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import CtaProductBox from "./CtaProductBox";

const sliderItems = [
  {
    id: 1,
    title: 'Training Treats (6oz)',
    image: '/images/slider-image-1.jpg',
    flavor: 'bacon'
  },
  {
    id: 2,
    title: 'Training Treats (6oz)',
    image: '/images/slider-image-2.jpg',
    flavor: 'chicken'
  },
  {
    id: 3,
    title: 'Crunchy Cat Treats (4oz)',
    image: '/images/slider-image-3.jpg',
    flavor: 'whitefish'
  },
  {
    id: 3,
    title: 'Crunchy Cat Treats',
    image: '/images/slider-image-6.jpg',
    flavor: 'chicken'
  }
];


const CtaProducts = () => {
  return (
    <div className="product-boxes home-slider-container">
      <div className="product-boxes home-slider-container">
        <Swiper
          modules={[Pagination]}
          pagination={{ el: ".slider-pagination", clickable: true }}
          slidesOffsetAfter={0}
          slidesPerGroup={1}
          breakpoints={{
            300: { slidesPerView: 1 },
            700: { slidesPerView: 2 },
            1000: { slidesPerView: 3 },
          }}
        >
          {sliderItems.map((item, index) => (
            <SwiperSlide key={`slide-${index}`}>
              <CtaProductBox
                product={item}
              />
            </SwiperSlide>
          ))}
          <div className="slider-pagination" />
        </Swiper>
      </div>
    </div>
  );
};

export default CtaProducts;
